<template>
  <div class="ui-wrap">
    <div class="ui-box">
      <!-- 每月报告 -->
      <p class="title">Monthly Report</p>
      <div class="content">
        <!-- 基本信息 -->
        <p class="topic">Basic Info</p>
        <div class="row">
          <div class="lab">Student Name:</div>
          <div class="info">{{ info.studentName }}</div>
        </div>
        <div class="row">
          <div class="lab">Date:</div>
          <div class="info">{{ getTime(info.createTime) }}</div>
        </div>
        <div class="row">
          <div class="lab">Tuition subject:</div>
          <div class="info">
            <input type="text" class="ipt" v-model="info.tuitionSubject" />
          </div>
        </div>
        <!-- 评介项目 -->
        <p class="topic">Rating items</p>
        <div class="row">
          <div class="lab">Performance</div>
          <div class="info">
            <el-rate
              v-model="info.performanceStar"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
        </div>
        <div class="row">
          <div class="lab">Effort</div>
          <div class="info">
            <el-rate
              v-model="info.effortStar"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
        </div>
        <div class="row">
          <div class="lab">Attitude</div>
          <div class="info">
            <el-rate
              v-model="info.attitudeStar"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
        </div>
        <div class="row">
          <div class="lab">Attendance</div>
          <div class="info">
            <el-rate
              v-model="info.attendanceStar"
              void-icon-class="voidrate"
              :icon-classes="['rated', 'rated', 'rated']"
            ></el-rate>
          </div>
        </div>
        <p class="lab2">Topics covered / Activities completed：</p>
        <textarea class="area" v-model="info.completedActivities"></textarea>
        <p class="lab2">Progress made and Weaknesses to be addressed：</p>
        <textarea class="area" v-model="info.comment"></textarea>
        <div class="btns">
          <a class="ui-btn gray" @click="goback">close</a>
          <a class="ui-btn" @click="submit">submit</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getTeachingChecklist, createReport } from '@/service/teacherApi.js'
import moment from 'moment'
export default {
  data() {
    return {
      info: {}
    }
  },
  methods: {
    goback() {
      window.history.go(-1)
    },
    async getTeachingChecklist() {
 
      const res = await getTeachingChecklist({ studyYear: this.$route.query.year, studyMonth: this.$route.query.month })
      if (res.data.status === 1) {
        if (!!this.$route.query.id) {
          this.info = res.data.data.find(item => item.id === Number(this.$route.query.id));
        }
      }
    },
    async createReport() {
      const res = await createReport(this.info)
      if (res.data.status === 1) {
        this.getTeachingChecklist();
        this.$message({ type: 'success', message: this.$t('common.commentsuccess') })
      }
    },
    getTime(time) {
      return moment(time * 1000).format('DD/MM/YYYY')
    },
    submit() {
      this.createReport()
    }
  },
  created() {
    this.getTeachingChecklist()
  }
}
</script>
<style lang="scss" scoped>
.title {
  padding: 42px 0 41px;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  border-bottom: 1px solid #d6d6d6;
}
.content {
  padding: 0 50px;
}
.topic {
  margin-top: 50px;
  font-size: 21px;
  line-height: 27px;
  font-weight: bold;
  padding-bottom: 10px;
}
.row {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.lab {
  min-width: 158px;
  margin-right: 20px;
  text-align: right;
  line-height: 19px;
}
.ipt {
  width: 690px;
  height: 42px;
  border-radius: 42px;
  padding: 10px 22px;
  line-height: 20px;
  border: 1px solid #ededed;
  background: #ededed;
  &:focus {
    border-color: #002147;
  }
}
.lab2 {
  margin: 30px 0 20px;
}
.area {
  width: 100%;
  height: 220px;
  resize: none;
  padding: 10px 20px;
  border: 1px solid #ddd;
  line-height: 24px;
  &:focus {
    border-color: #002147;
  }
}
.btns {
  padding: 100px 0;
  text-align: center;
  .ui-btn {
    margin: 0 25px;
  }
}
</style>